import React from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";

const SearchForm = ({
  listUserName,
  dataSearch,
  onChangeData,
  onChangeDate,
  onSearch,
  handleKeyDown,
}) => (
  <>
    <div className="search-new hidden-mobile-main">
      <div className="input-sm-new input-new-18">
        <label htmlFor="SearchText" className="font-color-default font-bold">
          Mã hợp đồng
        </label>
        <input
          id="SearchText"
          type="text"
          className="form-control input-sm"
          placeholder="Mã HD/ Tên KH"
          onChange={onChangeData("SearchText")}
          onKeyDown={handleKeyDown}
          value={dataSearch.SearchText}
        />
      </div>
      <div className="input-sm-new input-new-18">
        <label htmlFor="DateFrom" className="font-color-default font-bold">
          Từ ngày
        </label>
        <DateTimePicker
          id="DateFrom"
          value={dataSearch.DateFrom}
          onChange={onChangeDate("DateFrom")}
          placeholder="Từ ngày"
          name="DateFrom"
        />
      </div>
      <div className="input-sm-new input-new-18">
        <label htmlFor="DateTo" className="font-color-default font-bold">
          Đến ngày
        </label>
        <DateTimePicker
          id="DateTo"
          value={dataSearch.DateTo}
          onChange={onChangeDate("DateTo")}
          placeholder="Đến ngày"
          name="DateTo"
        />
      </div>
      <div className="input-sm-new input-new-18">
        <label htmlFor="sUsername" className="font-color-default font-bold">
          Nhân viên
        </label>
        <select
          id="sUsername"
          name="sUsername"
          value={dataSearch.sUsername}
          onChange={onChangeData("sUsername")}
          className="form-control input-sm"
        >
          <option value="">Tất cả</option>
          {listUserName &&
            listUserName.map((user, index) => (
              <option key={index} value={user.value}>
                {user.label}
              </option>
            ))}
        </select>
      </div>
      <div className="input-sm-new input-new-18">
        <label htmlFor="TypeChoVay" className="font-color-default font-bold">
          Kiểu vay
        </label>
        <select
          id="TypeChoVay"
          name="TypeChoVay"
          value={dataSearch.TypeChoVay}
          onChange={onChangeData("TypeChoVay")}
          className="form-control input-sm"
        >
          <option value="">Tất cả</option>
          <option value="3">Cầm đồ</option>
          <option value="1">Tín chấp</option>
          <option value="2">Trả góp</option>
          <option value="5">Bán hàng trả góp</option>
        </select>
      </div>
      <div className="input-sm-new input-new-10">
        <label htmlFor="Operator" className="font-color-default font-bold">
          So sánh
        </label>
        <select
          id="Operator"
          name="Operator"
          value={dataSearch.Operator}
          onChange={onChangeData("Operator")}
          className="form-control input-sm"
        >
          <option value="">Tất cả</option>
          <option value="<">&lt;</option>
          <option value="=">=</option>
          <option value=">">&gt;</option>
        </select>
      </div>
      <div className="input-sm-new input-new-18">
        <label htmlFor="SoTien" className="font-color-default font-bold">
          Số tiền (mặc định = 0)
        </label>
        <input
          id="SoTien"
          type="text"
          className="form-control input-sm"
          placeholder="Số tiền"
          onChange={onChangeData("SoTien")}
          onKeyDown={handleKeyDown}
          value={dataSearch.SoTien}
        />
      </div>
      <div className="input-sm-new input-new-10">
        <label htmlFor="pageSize" className="font-color-default font-bold">
          Bảng ghi
        </label>
        <select
          id="pageSize"
          className="form-control input-sm"
          value={dataSearch.pageSize}
          onChange={onChangeData("pageSize")}
        >
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={200}>200</option>
        </select>
      </div>
      <div className="input-sm-new input-new-18 search-main-new">
        <button
          type="submit"
          className="btn btn-info-new"
          style={{ marginTop: "28px", paddingTop: "7px" }}
          onClick={onSearch}
        >
          <i className="la la-search"></i>
          <span> &nbsp; Tìm kiếm</span>
        </button>
      </div>
    </div>
  </>
);

export default SearchForm;
